// extracted by mini-css-extract-plugin
export default {"wrapper":"ShopNameComponent_wrapper__7JbTP","title":"ShopNameComponent_title__Q6Fon","subtitle":"ShopNameComponent_subtitle__k-INQ"};